import { NavLink } from "react-router-dom";
import DiskIcon from "./Icons/DiskIcon";
import { ReactNode } from "react";

interface IProps {
  to: string;
  name: string;
  icon?: ReactNode;
  sideBarCollapse?: boolean;
}

export default function SideBarNav({
  to,
  name,
  icon,
  sideBarCollapse,
}: IProps) {
  return (
    <div className="w-full px-4 relative overflow-visible mb-1">
      <NavLink
        to={to}
        className={({ isActive }) =>
          `${
            isActive ? "active" : ""
          } transition-all duration-300 py-10px pl-4 text-base w-full flex items-center justify-between hover:pl-6 text-[#000] font-semibold`
        }
      >
        <div className="w-full flex items-center gap-x-5">
          {icon ?? <DiskIcon />}
          {((sideBarCollapse === false && icon !== undefined) ||
            (sideBarCollapse === false && icon === undefined)) && (
            <p className="text-ellipsis text-nowrap overflow-hidden">{name}</p>
          )}
        </div>
      </NavLink>
    </div>
  );
}
